import React, { Component } from 'react';
import { Card } from 'react-bootstrap';
import { servicesCategoryMap, categoryImageMap } from './servicesConstants'
import findKey from 'lodash/findKey';

class ServicesCard extends Component {
    onCardClick(label, event) {
        event.stopPropagation();
        if (this.props.onCardClick)
            this.props.onCardClick(label);
    }
    serviceCardError = (e)=>{
         e.target.onerror = null;
         e.target.src = `/images/global/personalizer/image-not-available-640.jpg`
    }
    tickIcon(selected) {
        return (!selected ? this.tickIconHover(selected) : <svg focusable="false" className="svg-icon svg-icon-open-close"><use xlinkHref="#icon-circle-checkmark"></use></svg>)
    }
    tickIconHover(selected) {
        return (selected ? this.tickIcon(selected) : <svg focusable="false" className="svg-icon svg-icon-open-close rotate45"><use xlinkHref="#icon-open-close"></use></svg>)
    }

    render() {
        let textlable = findKey(servicesCategoryMap, (item) => item === this.props.labelText) || this.props.labelText;
        let imageName = categoryImageMap[this.props.labelText]
        let image = `${process.env.imageUrl}/${imageName}`;
        return (
            <div data-test-id={this.props.dataId} onClick={this.onCardClick.bind(this, textlable)}>
                <Card className='img-responsive-wrapper card-col '>
                    <div className={`overlay overlay-${(this.props.isSelectedCategory) ? 'show' : 'hidden'} image-hover`}>
                        <div aria-hidden='true' className="tick-icon">{this.tickIcon(this.props.isSelectedCategory)}</div>
                        <div aria-hidden='true' className="tick-icon-hover">{this.tickIconHover(this.props.isSelectedCategory)}</div>
                    </div>
                    <Card.Img alt='' onError={this.serviceCardError}
                        className="spa-card-image " variant="top" data-test-id="image-title" src={image} />

                </Card>
                <Card.Body className={(this.props.isSelectedCategory) ? 'selected-services-card-body' : 'services-card-body'} >
                    <Card.Title className="font-size-p2 gotham-xn-medium title-hover" >{textlable}</Card.Title>
                </Card.Body>
            </div>
        );
    }
}



export default ServicesCard;